import { DEBUG_SAVE_AS_V2 } from "./debug"

export const CONFIG_SAVE_AS_V2 = DEBUG_SAVE_AS_V2
